<template>
  <div class="card u-pad-x-md u-pad-y-sm" :class="'u-bg-'+bg">
    <div class="card__header u-flex u-between u-marg-b-sm">
      <ul>
        <li v-for="tag in content.sbsSubject" class="u-inline-block u-marg-r-sm"><app-tag :content="tag" /></li>
      </ul>

      <button class="card__header__btn-fav t-button--simple u-relative" :class="{'is-active': isFav}" @click="onToggleFav">
        <img src="/images/fav-border.svg" alt="" class="card__header__btn-fav__ico u-full-width">
        <img src="/images/fav-gradient.svg" alt="" class="card__header__btn-fav__ico u-absolute u-full-width">
      </button>
    </div>

    <router-link @click.native="$ga.send('Building', 'Click', 'Content navigation')" class="card__content u-left u-full-width" :to="url !== '' ? url : content.url">
      <template v-if="content.sectionHandle === 'sbsArticle'">
        <p class="t-h3 u-white">{{content.title}}</p>
      </template>

      <template v-else>
        <div class="u-inline-block u-w2of8">
          <img v-if="content.sectionHandle === 'sbsVideo'" src="/images/play-gradient.svg" alt="" class="card__content__ico u-block u-w6of8">
          <img v-if="content.sectionHandle === 'sbsPdf'" src="/images/pdf-gradient.svg" alt="" class="card__content__ico u-block u-w6of8">
          <img v-if="content.sectionHandle === 'sbsPpt'" src="/images/ppt-gradient.svg" alt="" class="card__content__ico u-block u-w6of8">
        </div>
        <p class="t-h3 u-white u-inline-block u-w6of8">{{content.title}}</p>
      </template>

      <div v-if="content.date" class="u-flex u-between u-pad-t-sm">
        <p class="t-text--small u-grey-light"><strong v-if="content.sbsAuthor && content.sbsAuthor.length > 0" class="t-light u-white">{{content.sbsAuthor[0].title}} -</strong> {{formatDate(content.date)}}</p>
        <p v-if="content.sbsDuration" class="t-text--small t-text--gradient-green">{{content.sbsDuration}}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
import AppTag from '@/components/common/AppTag'
import Favorite from '@/components/common/Favorite'

export default {
  components:
  {
    AppTag
  },

  mixins: [Favorite],

  props: {
    index: {
      type: Number,
      default: 0
    },
    content: {
      type: Object,
      default: null
    },
    bg: {
      type: String,
      default: 'grey'
    },
    url: {
      type: String,
      default: ''
    }
  },

  // computed: {
  //   currentUrl () {
  //     return this.url !== '' ? this.url : '/district/' + this.$route.params.slug + '/' + this.$route.params.id + '/' + this.content.slug
  //   }
  // },

  methods: {
    formatDate (date) {
      date = new Date(date)
      return `${this.formatMonth(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`
    },

    formatMonth (mounth) {
      switch (mounth){
        case 0:
          return 'Jan'
          break
        case 1:
          return 'Fev'
          break
        case 2:
          return 'Mar'
          break
        case 3:
          return 'Apr'
          break
        case 4:
          return 'May'
          break
        case 5:
          return 'Jun'
          break
        case 6:
          return 'Jul'
          break
        case 7:
          return 'Aug'
          break
        case 8:
          return 'Sep'
          break
        case 9:
          return 'Oct'
          break
        case 10:
          return 'Nov'
          break
        case 11:
          return 'Dec'
          break
        default:
          return ''
          break
      }
    },

    // onOpenModal () {
    //   if(this.content.sectionHandle === 'sbsArticle')
    //   {
    //     return
    //   }
    //   else
    //   {
    //     this.$emit('modal:open', this.content)
    //   }
    // }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

  .card
    border-radius 17px
    transform translateZ(0)
    transition transform .6s ease-out-quint, opacity .4s
    
    &-enter,
    &-leave-to
      opacity 0
      
    &-enter
      transform translateX(-10px) translateZ(0)
      
    &-leave-to
      transform translateX(10px) translateZ(0)
      
  .card__header__btn-fav
    width 20px
  
  .card__header__btn-fav__ico
    top 0
    left 0
    transform translateZ(0)

    &:nth-child(1)
      opacity 1
      
      .card__header__btn-fav.is-active &
        opacity 0

    &:nth-child(2)
      opacity 0
      
      .card__header__btn-fav.is-active &
        opacity 1

  .card__content__ico
    max-width 108px

</style>